import React, { useState, useEffect, useCallback } from "react";
import { Box } from "@mui/material";
import ListaSorteio from "../ListaSorteio";
import CriarSorteio from "../CriarSorteio";

export type SystemType = "ANUNCIO360" | "ESCALA11";

interface GerenciarSorteioProps {
  token: string;
  role: "MASTER" | "PARTNER" | "ANALYST";
  system: SystemType;
}

const GerenciarSorteio: React.FC<GerenciarSorteioProps> = ({
  token,
  role,
  system,
}) => {
  const [refreshListKey, setRefreshListKey] = useState(0);

  const handleSorteioUpdate = useCallback(() => {
    setRefreshListKey((prevKey) => prevKey + 1);
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      {role == "MASTER" && (
        <CriarSorteio
          token={token}
          role={role}
          onSorteioCreated={handleSorteioUpdate}
          system={system}
        />
      )}

      <ListaSorteio
        key={refreshListKey}
        token={token}
        role={role}
        system={system}
      />
    </Box>
  );
};

export default GerenciarSorteio;
